import React, { useEffect, useRef, useState, useContext } from 'react';
import Chart from 'chart.js/auto';
import { ApiContext } from '../../../../../context/MyContext';
import * as userService from '../../../../../service/userService';
import SleepGraphModal from '../DataGraphs/SleepGraphModal';
import Button from '../../../../../common/Button/Button';
const SleepChart = ({ profileId, selectedDate, eventTypeId }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);
  const { get } = useContext(ApiContext);
  const [value, setValue] = useState(0);
  const [recommended, setRecommended] = useState(8);
  const [hasData, setHasData] = useState(true);
  const [showGraph, setShowGraph] = useState(false);
  useEffect(() => {
    if (!eventTypeId) return;
    const fetchSleep = async () => {
      const result = await userService.fetchSleepSummary(get, profileId, 'D', selectedDate, eventTypeId);
      if (result.success && result.data.length > 0) {
        const { value, recommended } = result.data[0];
        setValue(value);
        setRecommended(recommended || 8);
        setHasData(true);
      } else {
        setHasData(false);
      }
    };
    fetchSleep();
  }, [get, profileId, selectedDate, eventTypeId]);

  useEffect(() => {
    if (!chartRef.current || !hasData) return;

    // Clear old chart if any
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    chartInstanceRef.current = new Chart(chartRef.current, {
      type: 'bar',
      data: {
        labels: ['Sleep'],
        datasets: [
          {
            label: 'Actual Sleep',
            data: [value],
            backgroundColor: '#FF6414',
            stack: 'sleep',
            borderRadius: { bottomLeft: 10, bottomRight: 10 },
            borderSkipped: false
          },
          {
            label: 'Remaining Sleep',
            data: [Math.max(recommended - value, 0)],
            backgroundColor: '#FFF0E8',
            stack: 'sleep',
            borderRadius: { topLeft: 10, topRight: 10 },
            borderSkipped: false
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            display: false,
            stacked: true,
            grid: { display: false },
            ticks: { display: false }
          },
          y: {
            display: false,
            stacked: true,
            min: 0,
            max: Math.max(recommended, value + 1), 
            grid: { display: false },
            ticks: { display: false }
          }
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.dataset.label}: ${ctx.raw} hrs`
            }
          }
        }
      }
    });

    return () => {
      chartInstanceRef.current?.destroy();
    };
  }, [hasData, value, recommended]);

  return (
    <div className="bg-white rounded-xl shadow-md w-[260px] h-[360px] flex flex-col items-center justify-center text-center p-4">
      <div className="text-xl font-semibold leading-tight"> Sleep Analytics </div>
      {hasData ? (
        <>
          <div className="flex-1 w-full">
            <canvas ref={chartRef} className="w-full h-full" />
          </div>
          <div className="py-2">
            <p className="text-sm font-semibold leading-tight">
              Sleep<br />{value} hrs
            </p>
          </div>
        </>
      ) : (
        <p className="text-sm text-gray-500 font-medium leading-snug">
          No sleep data available<br />
          for the day.<br />
          Remind the client to track it.
        </p>
      )}
      <div>
      <Button  
       text = "View Trends" 
       onClick={() => setShowGraph(true)} 
       className="bg-orange-primary hover:bg-dark-orange w-32"/>
      </div>
       
{showGraph && (
  <SleepGraphModal
    profileId={profileId}
    selectedDate={selectedDate}
    eventTypeId={eventTypeId}
    onClose={() => setShowGraph(false)}
  />
)}
    </div>
  );
};

export default SleepChart;
